// SimplyRefer Reference workflow — privacy-first referrals (no patient health info).

// Generate a short, human-friendly referral reference, e.g. "SR-4092".
export const genToken = () => `SR-${Math.floor(1000 + Math.random() * 9000)}`;

// Copy-paste snippet a GP hands to the patient. Contains NO patient detail.
export function bookingSnippet({ token, clinician }) {
  const c = clinician || {};
  const name = `${c.first_name || ""} ${c.last_name || ""}`.trim();
  const loc = `${c.suburb || ""}${c.state ? ", " + c.state : ""}${c.postcode ? " " + c.postcode : ""}`.trim();
  return [
    `SimplyRefer Reference: #${token}`,
    ``,
    `Clinician: ${name}${c.profession ? " — " + c.profession : ""}`,
    c.specialty ? `Specialty: ${c.specialty}` : null,
    loc ? `Location: ${loc}` : null,
    c.phone ? `Phone: ${c.phone}` : null,
    c.email ? `Email: ${c.email}` : null,
    ``,
    `Referred via SimplyRefer — please record SimplyRefer Reference #${token}, which identifies the referring practice.`,
  ]
    .filter((l) => l !== null)
    .join("\n");
}

// Aggregate optional SimplyRefer References created in the current calendar month, grouped by GP clinic.
export function topClinicsThisMonth(tokens) {
  const now = new Date();
  const counts = {};
  for (const t of tokens || []) {
    const d = new Date(t.created_at);
    if (d.getFullYear() !== now.getFullYear() || d.getMonth() !== now.getMonth()) continue;
    const name = (t.gp_clinic_name || "Unknown clinic").trim() || "Unknown clinic";
    counts[name] = (counts[name] || 0) + 1;
  }
  return Object.entries(counts)
    .map(([name, count]) => ({ name, count }))
    .sort((a, b) => b.count - a.count);
}
